<div class="main-container">
  <div class="main-content">
    <!-- Document Type Cards -->
     
    <!-- <div class="document-cards">
      <div *ngFor="let card of documentCategories" 
     class="document-card"
     [class.selected]="card.isActive"
     (click)="setActiveDocument(card)">
      <div class="card-content">
        <span class="title">{{card.title}}</span>
        <span class="subtitle">Documents</span>
        <div class="count-container">
          <span class="count">{{card.count}}</span>
          <div class="icon-container">
            <i class="material-icons">{{card.icon}}</i>
          </div>
        </div>
      </div>
    </div>
    </div> -->

    <div class="card-scroll-wrapper">
    <button class="scroll-btn left" (click)="scrollLeft()">
      <i class="material-icons">chevron_left</i>
    </button>

  <div class="document-cards" #cardContainer>
    <div *ngFor="let card of documentCategories" 
         class="document-card"
         [class.selected]="card.isActive"
         (click)="setActiveDocument(card)">
          
        <div class="card-content">
          <div class="card-header">
            <span class="title">{{card.title}}</span>
              <div class="actions" *ngIf="!['identity','personal','legalfinance','others','health'].includes((card.title || '').toLowerCase())">
                <i class="bi bi-pencil-square" (click)="onEditCategory(card)"></i>
                <i class="bi bi-trash3-fill" (click)="onDeleteCategory(card)"></i>
              </div>
          </div>
          <span class="subtitle">Documents</span>
          <div class="count-container">
            <span class="count">{{card.count}}</span>
             <div class="icon-container">
        <!-- Use image instead of Material icon -->
        <img [src]="getIconImagePath(card.icon)" 
             class="category-icon"
             width="24" 
             height="24"
             (error)="onImageError($event)" />
      </div>
          </div>
        </div>

    </div>
  </div>

  <button class="scroll-btn right" (click)="scrollRight()">
  <i class="material-icons">chevron_right</i>
</button>
</div>

     
    <div class="list-header">
      <h2>List Of Documents</h2>
      <div class="header-actions">

        <!-- Trigger Button -->
        <div class="country-selector" [matMenuTriggerFor]="menu" (click)="getCitizenships()">
          <img [src]="getCountryImagePath(selectedCitizenship?.country)" alt="flag" 
          width="24" height="16" style="margin-right: 8px;" />
          <span>{{ selectedCitizenship?.country || 'Select Country' }}</span>
          <i class="material-icons">expand_more</i>
        </div>

        <!-- Dropdown Menu -->
        <mat-menu #menu="matMenu">
          <ng-container *ngIf="citizenships.length > 0; else noCitizenships">
            <button mat-menu-item *ngFor="let item of citizenships" (click)="selectCitizenship(item)">
              <img [src]="getCountryImagePath(item.country)" alt="{{ item.country }} flag" 
              width="24" height="16" style="margin-right: 8px;" />
              {{ item.country }}
            </button>
          </ng-container>
          <ng-template #noCitizenships>
            <span class="p-2 text-muted">No citizenships found</span>
          </ng-template>
        </mat-menu>

        <!-- # add new document button with dropdown menu -->
        <button
          class="add-new-btn"
          mat-raised-button
          [matMenuTriggerFor]="menudoc"
          #menuTrigger="matMenuTrigger"
        >
          <span class="btn-text">Add New</span>
          <i class="material-icons expand-icon">{{ menuTrigger.menuOpen ? 'expand_less' : 'expand_more' }}</i>
        </button>
          <mat-menu #menudoc="matMenu">
            <button 
              *ngFor="let option of dropdownOptions" 
              mat-menu-item 
              (click)="option.action()"
              class="menu-item">
              <div class="menu-item-content">
                <i class="material-icons">{{ option.icon }}</i>
                <span>{{ option.label }}</span>
              </div>
            </button>
          </mat-menu>

      </div>
    </div>

    <!-- Document List Section -->
    <div class="document-list">
      <div class="search-section">
        <div class="search-container">
          <i class="material-icons">search</i>
          <input class="search-text" type="text" [(ngModel)]="searchText" placeholder="Search for Document..." 
                 (keyup)="searchDocuments(searchText)">
        </div>
        <div class="view-options" >
          <button 
            class="sort-btn" 
            mat-raised-button 
            [matMenuTriggerFor]="sortMenu">
            <i class="material-icons">sort</i>
          </button>
          
          <mat-menu #sortMenu="matMenu">
            <button 
              *ngFor="let option of sortOptions" 
              mat-menu-item 
              (click)="option.action()">
              <i class="{{ option.icon }}" style="margin-right: 8px; font-size: 20px; -webkit-text-stroke: 0.5px; vertical-align: middle;"></i>
              <!-- <i class="material-icons">{{option.icon}}</i> -->
              <span>{{ option.label }}</span>
            </button>
          </mat-menu>
          <button class="view-btn" (click)="toggleView()">
            <i class="material-icons">{{ viewMode === 'grid' ? 'view_list' : 'grid_view' }}</i>
          </button>  
        </div>
      </div>

      <!-- Display Documents -->
      <ng-container *ngIf="allDocuments.length > 0; else emptyState">
        <!-- List View -->
        <div class="table-container" *ngIf="viewMode === 'list'">
          <table mat-table *ngIf="tagSelected === 'identity'" [dataSource]="dataSource" class="document-table">
            <!-- Document Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Document Name <i class="bi bi-arrow-down-up" (click)="sortData('name')"></i></th>
              <td mat-cell *matCellDef="let doc">
                <div class="document-name-cell">
                  <img class="docmat" src="assets/images/docs.png" alt="document icon">
                  <span>{{doc.doctype | doctype}}</span>
                </div>
              </td>
            </ng-container>
            
            <!-- Description Column -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>DocId</th>
              <td mat-cell *matCellDef="let doc">{{doc.docid}}</td>
            </ng-container>

            <!-- Upload Date Column -->
            <ng-container matColumnDef="uploadedOn">
              <th mat-header-cell *matHeaderCellDef>Uploaded On <i class="bi bi-arrow-down-up" (click)="sortData('uploadDate')"></i></th>
              <td mat-cell *matCellDef="let doc">{{formatDate(doc.uploadDate)}}</td>
            </ng-container>

            <!-- Expiration Date Column -->
            <ng-container matColumnDef="expiringOn">
              <th mat-header-cell *matHeaderCellDef>Expiring On <i class="bi bi-arrow-down-up" (click)="sortData('expirationDate')"></i></th>
              <td mat-cell *matCellDef="let doc">
                {{doc.expirationDate ? formatDate(doc.expirationDate) : 'NA'}}
              </td>
            </ng-container>

            <!-- Tags Column -->
            <ng-container matColumnDef="tags">
              <th mat-header-cell *matHeaderCellDef>Tags</th>
              <td mat-cell *matCellDef="let doc">
                <ng-container *ngIf="doc.user_tags?.length; else noTags">
                  <mat-chip-list>
                    <mat-chip *ngFor="let tag of doc.user_tags" color="primary" selected><span class="tag-text" [matTooltip]="tagTooltip(tag)" matTooltipClass="tag-tooltip" [matTooltipShowDelay]="200" matTooltipPosition="above">{{ truncateTag(tag) }}</span></mat-chip>
                  </mat-chip-list>
                </ng-container>
                <ng-template #noTags>NA</ng-template>
              </td>
            </ng-container>


            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let doc">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu">
                  <i class="material-icons">more_vert</i>
                </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="onDocumentAction('view', doc)">
                      <mat-icon>visibility</mat-icon>
                      <span>View</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('edit', doc)">
                      <mat-icon>edit</mat-icon>
                      <span>Edit</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('share', doc)">
                      <mat-icon>share</mat-icon>
                      <span>Share</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('download', doc)">
                      <mat-icon>download</mat-icon>
                      <span>Download</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('delete', doc)">
                      <mat-icon>delete</mat-icon>
                      <span>Delete</span>
                    </button>
                  </mat-menu>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <table mat-table *ngIf="tagSelected !== 'identity'" [dataSource]="dataSource" class="document-table">
            <!-- Document Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Document Name <i class="bi bi-arrow-down-up" (click)="sortData('name')"></i></th>
              <td mat-cell *matCellDef="let doc">
                <div class="document-name-cell">
                  <img class="docmat" src="assets/images/docs.png" alt="document icon">
                  <span>{{doc.name}}</span>
                </div>
              </td>
            </ng-container>
            
            <!-- Description Column -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Description</th>
              <td mat-cell *matCellDef="let doc">{{doc.description}}</td>
            </ng-container>

            <!-- Upload Date Column -->
            <ng-container matColumnDef="uploadedOn">
              <th mat-header-cell *matHeaderCellDef>Uploaded On <i class="bi bi-arrow-down-up" (click)="sortData('uploadDate')"></i></th>
              <td mat-cell *matCellDef="let doc">{{formatDate(doc.uploadDate)}}</td>
            </ng-container>

            <!-- Expiration Date Column -->
            <ng-container matColumnDef="expiringOn">
              <th mat-header-cell *matHeaderCellDef>Expiring On <i class="bi bi-arrow-down-up" (click)="sortData('expirationDate')"></i></th>
              <td mat-cell *matCellDef="let doc">
                {{doc.expirationDate ? formatDate(doc.expirationDate) : 'NA'}}
              </td>
            </ng-container>

            <!-- Tags Column -->
            <ng-container matColumnDef="tags">
              <th mat-header-cell *matHeaderCellDef>Tags</th>
              <td mat-cell *matCellDef="let doc">
                <ng-container *ngIf="doc.user_tags?.length; else noTags">
                  <mat-chip-list>
                    <mat-chip *ngFor="let tag of doc.user_tags" color="primary" selected><span class="tag-text" [matTooltip]="tagTooltip(tag)" matTooltipClass="tag-tooltip" [matTooltipShowDelay]="200" matTooltipPosition="above">{{ truncateTag(tag) }}</span></mat-chip>
                  </mat-chip-list>
                </ng-container>
                <ng-template #noTags>NA</ng-template>
              </td>
            </ng-container>


            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let doc">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu">
                  <i class="material-icons">more_vert</i>
                </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="onDocumentAction('view', doc)">
                      <mat-icon>visibility</mat-icon>
                      <span>View</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('edit', doc)">
                      <mat-icon>edit</mat-icon>
                      <span>Edit</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('share', doc)">
                      <mat-icon>share</mat-icon>
                      <span>Share</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('download', doc)">
                      <mat-icon>download</mat-icon>
                      <span>Download</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('delete', doc)">
                      <mat-icon>delete</mat-icon>
                      <span>Delete</span>
                    </button>
                  </mat-menu>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>

        <!-- Grid View -->
        <div *ngIf="viewMode === 'grid'" class="grid-view">
          <div *ngFor="let doc of paginatedGridData" class="document-card">
            <div class="document-preview" (click)="openPreview(doc)">
              <!-- <ng-container [ngSwitch]="doc.mimeType">
                <img *ngSwitchCase="'image/jpeg'" [src]="doc.previewUrl" [alt]="doc.name" class="doc-image" />
                <img *ngSwitchCase="'image/png'" [src]="doc.previewUrl" [alt]="doc.name" class="doc-image" />
                <div *ngSwitchDefault class="default-preview">
                  <img class="doc-icon" src="assets/images/file.svg" alt="document icon" 
                  style="width: 100%;height: 12rem;object-fit: fill;"/>
                </div>
              </ng-container> -->
              <ng-container *ngIf="doc as d">
                <img *ngIf="isImage(d.mimeType)" [src]="d.previewUrl" [alt]="d.name" class="doc-image" />
                <iframe *ngIf="d.mimeType === 'application/pdf'" [src]="d.previewUrl" width="100%" height="200"></iframe>
                <div *ngIf="!isImage(d.mimeType) && d.mimeType !== 'application/pdf'" class="default-preview">
                  <img class="doc-icon" src="assets/images/file.svg" alt="document icon"
                    style="width: 100%; height: 12rem; object-fit: fill;" />
                </div>
              </ng-container>
            </div>
            <div class="document-info">
              <h3 class="document-name">{{doc.name}}</h3>
              <h3 *ngIf="tagSelected === 'identity'" class="document-name">{{doc.doctype | doctype}}</h3>
              <p class="document-date">{{formatDate(doc.uploadDate)}}</p>
              <div class="document-actions">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu">
                  <i class="material-icons">more_vert</i>
                </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="onDocumentAction('view', doc)">
                      <mat-icon>visibility</mat-icon>
                      <span>View</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('edit', doc)">
                      <mat-icon>edit</mat-icon>
                      <span>Edit</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('share', doc)">
                      <mat-icon>share</mat-icon>
                      <span>Share</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('download', doc)">
                      <mat-icon>download</mat-icon>
                      <span>Download</span>
                    </button>
                    <button mat-menu-item (click)="onDocumentAction('delete', doc)">
                      <mat-icon>delete</mat-icon>
                      <span>Delete</span>
                    </button>
                  </mat-menu>
              </div>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <mat-paginator
          [length]="dataSource?.data?.length || 0"
          [pageSize]="10"
          [pageSizeOptions]="[5, 10, 25, 100]"
          [showFirstLastButtons]="true"
          (page)="onPageChange($event)"
          aria-label="Select page">
        </mat-paginator>

        
      </ng-container>

      <!-- Document Preview Modal -->
      <!-- <div *ngIf="isPreviewOpen" class="preview-modal">
        <div class="preview-content">
          <div class="preview-header">
            <h2>{{previewDocument?.name}}</h2>
            <button mat-icon-button (click)="closePreview()">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="preview-body">
            <ng-container *ngIf="previewDocument" [ngSwitch]="previewDocument.mimeType">
              <img *ngSwitchCase="'image/jpeg'" [src]="previewDocument.previewUrl" [alt]="previewDocument.name">
              <img *ngSwitchCase="'image/png'" [src]="previewDocument.previewUrl" [alt]="previewDocument.name">
              <iframe width="98%" margin-top="20px" height="80%" *ngSwitchCase="'application/pdf'" [src]="previewDocument.previewUrl" frameborder="0"></iframe>
              <div *ngSwitchDefault class="no-preview">
                <img class= "docmat" src="assets/images/docs.png" alt="document icon">
                <p>Preview not available for this file type</p>
              </div>
            </ng-container>
          </div>
        </div>
      </div> -->

      <!-- Document Preview Modal2 -->
      <!-- Rendered through the CDK overlay container (see openPreview/isPreviewOpen in the .ts) so it
           sits above the sidebar/header instead of inside the page-content stacking context. -->
      <ng-template #previewTpl>
       <div class="preview-modal">
        <div class="preview-content">
          <div class="preview-header">
            <h2>{{ previewDocument?.name }}</h2>
            <button mat-icon-button (click)="closePreview()">
              <i class="material-icons">close</i>
            </button>
          </div>

          <div class="iframe-wrapper">
            <div *ngIf="isPreviewLoading" class="iframe-spinner-overlay">
              <mat-spinner diameter="40"></mat-spinner>
              <p>Loading document preview...</p>
            </div>

            <ng-container *ngIf="!isPreviewLoading && previewDocument">
              <iframe width="100%" height="100%"  *ngIf="previewDocument.mimeType === 'application/pdf'" [src]="previewDocument.previewUrl" frameborder="0"></iframe>

             
              <img
                  *ngIf="isImage(previewDocument.mimeType)"
                  [src]="previewDocument.previewUrl"
                  [alt]="previewDocument.name"
                  class="preview-image" />

                <!-- Default / Unsupported types -->
                <div *ngIf="!isImage(previewDocument.mimeType) && previewDocument.mimeType !== 'application/pdf'" class="no-preview">
                  <img class="docmat" src="assets/images/docs.png" alt="document icon">
                  <p>Preview not available for this file type</p>
                </div>

             
            </ng-container>
          </div>
        </div>
      </div> 
      </ng-template>


      <!-- <div class="preview-body">
        <div *ngIf="isPreviewLoading" class="iframe-loader">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Loading document preview...</p>
        </div>
      
        <ng-container *ngIf="!isPreviewLoading && previewDocument" [ngSwitch]="previewDocument.mimeType">
          <img *ngSwitchCase="'image/jpeg'" [src]="previewDocument.previewUrl" [alt]="previewDocument.name">
          <img *ngSwitchCase="'image/png'" [src]="previewDocument.previewUrl" [alt]="previewDocument.name">
          <iframe width="98%" height="80%" *ngSwitchCase="'application/pdf'" [src]="previewDocument.previewUrl"
            frameborder="0"></iframe>
          <div *ngSwitchDefault class="no-preview">
            <img class="docmat" src="assets/images/docs.png" alt="document icon">
            <p>Preview not available for this file type</p>
          </div>
        </ng-container>
      </div> -->





      <!-- Empty State -->
      <ng-template #emptyState>
        <div class="empty-state">
          <div class="upload-illustration">
            <img class="docimg" src="assets/images/docempty.png" alt="Upload documents">
          </div>
          <h3>No Documents Yet..</h3>
          <p>Secure and organize your documents by start uploading it.</p>
          <button class="add-documents-btn" (click)="onAddDocument()">Add documents</button>
        </div>
      </ng-template>
    </div>
  </div>
</div>